import React, { useEffect, useMemo, useState } from "react";
import { AlertTriangle, Loader2, XCircle } from "lucide-react";

export default function DossierGenerating({ dossier, status, error, onBackToForm, onTryAgain }) {
  const [messageIndex, setMessageIndex] = useState(0);
  const [progress, setProgress] = useState(8);
  const prospectName = dossier?.prospect_name || "this prospect";
  const company = dossier?.prospect_company || "their company";

  const messages = useMemo(() => [
    `Searching The Web For ${prospectName}...`,
    `Researching ${company}'s Business Model...`,
    "Analysing Recent Activity And Signals...",
    "Building Pain Point Analysis...",
    "Mapping KPIs And Discovery Questions...",
    "Writing Strategic Insight...",
    "Finalising Your Dossier...",
  ], [company, prospectName]);

  const stopped = status === "failed" || status === "needs_input" || status === "stalled";

  useEffect(() => {
    if (stopped) return undefined;
    const id = window.setInterval(() => setMessageIndex((value) => (value + 1) % messages.length), 4000);
    return () => window.clearInterval(id);
  }, [messages.length, stopped]);

  useEffect(() => {
    if (stopped) return undefined;
    const id = window.setInterval(() => setProgress((value) => Math.min(value + 4, 94)), 2500);
    return () => window.clearInterval(id);
  }, [stopped]);

  if (status === "needs_input") {
    return (
      <div className="dossier-generating">
        <div className="dossier-alert warning large">
          <AlertTriangle size={22} />
          <div>
            <strong>More Context Needed</strong>
            <p>{error || "Paste The Prospect's LinkedIn Profile Or Company Page Text And Regenerate."}</p>
            <button className="Outline-Button Small" onClick={onBackToForm}>Go Back And Add Context</button>
          </div>
        </div>
      </div>
    );
  }

  if (status === "stalled") {
    return (
      <div className="dossier-generating">
        <div className="dossier-alert warning large">
          <AlertTriangle size={22} />
          <div>
            <strong>Taking longer than usual</strong>
            <p>This dossier is still being prepared. You can close this window; it will be in your history when it is ready.</p>
            <button className="Outline-Button Small" onClick={onBackToForm}>Back</button>
          </div>
        </div>
      </div>
    );
  }

  if (status === "failed") {
    return (
      <div className="dossier-generating">
        <div className="dossier-alert error large">
          <XCircle size={22} />
          <div>
            <strong>Generation Failed</strong>
            <p>{error || "The Dossier Could Not Be Generated."}</p>
            <button className="Outline-Button Small" onClick={onTryAgain}>Try Again</button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="dossier-generating">
      <div>
        <h2>{prospectName}</h2>
        <p>{company}</p>
      </div>
      <div className="dossier-pulse-ring">
        <Loader2 size={34} className="dossier-spin" />
      </div>
      <strong>{messages[messageIndex]}</strong>
      <div className="dossier-progress">
        <span style={{ width: `${progress}%` }} />
      </div>
      <small>Usually Takes 30-90 Seconds</small>
    </div>
  );
}
